// SurveyGroupSelector.js
import React, { useState } from 'react';
import { Box, Button, HStack, Text, useColorModeValue } from '@chakra-ui/react';

const SurveyGroupSelector = ({ onSelectGroup }) => {
  const [activeGroup, setActiveGroup] = useState(null);

  const groups = [
    {
      name: "Becas 2025",
      surveys: ["becas-2025", "becas-2025-archivos"]
    },
    {
      name: "Matrículas 2025",
      surveys: ["pre-matriculas-2025-contrato", "pre-matriculas-2025-salud", "pre-matriculas-2025-antecedentes"]
    },
    {
      name: "Becas 2026 (Archivos)",
      surveys: ["becas-2026", "becas-2026-archivos"]
    },
    {
      name: "Becas 2027",
      surveys: ["becas-2027-socioeconomica", "becas-2027-funcionario", "becas-2027-cambio-economico"]
    }
  ];

  const buttonBg = useColorModeValue('gray.100', 'gray.700');
  const buttonHoverBg = useColorModeValue('gray.200', 'gray.600');
  const activeBg = useColorModeValue('teal.500', 'teal.300');
  const activeColor = useColorModeValue('white', 'gray.800');

  const handleSelect = (group) => {
    setActiveGroup(group.name);
    onSelectGroup(group.surveys);
  };

  const handleClear = () => {
    setActiveGroup(null);
    onSelectGroup([]);
  };

  return null;
};

export default SurveyGroupSelector;